import { render } from "./Separator.vue?vue&type=template&id=4e734444&scoped=true&ts=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"

import "./Separator.vue?vue&type=style&index=0&id=4e734444&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e734444"]])

export default __exports__